import {useMemo} from "react"
import {useSelector} from "react-redux"

const WEEKLY_ADS_SLUG = "from-our-weekly-ads"

export default function useDepartmentList() {
  const {departmentTree, searchDepartmentTree} = useSelector(
    state => state.product
  )
  
  const updatedDepartmentTree = useMemo(
    () =>
      searchDepartmentTree?.map(d => ({
        ...d,
        text: d.name,
      })),
    [searchDepartmentTree]
  )

  const updatedOtherDepartmentTree = useMemo(() => {
    const searchDepartmentCategoryIds = searchDepartmentTree?.map(
      s => s.category_ids
    )

    return departmentTree?.filter(
      d => !searchDepartmentCategoryIds?.includes(d.category_ids)
    )
  }, [departmentTree, searchDepartmentTree])

  // add "All Products", "All Coupons"
  const searchTypeDropDownOption = useSelector(
    ({common}) => common.commonDetailsData.top_dropdown_section
  )

  // get weekly ads
  const { sub_department = [] } = useSelector(
    ({ common }) => common?.commonDetailsData?.ecom_section || {}
  );
  const weeklyAds = sub_department?.find(i => i.slug === WEEKLY_ADS_SLUG)
  const prependItems = useMemo(() => {
    const items = [...searchTypeDropDownOption]
    if (weeklyAds) {
      items.splice(1, 0, weeklyAds)
    }
    return items
  }, [searchTypeDropDownOption, weeklyAds])

  const productCategoryAndWeeklyAds = useMemo(
    () =>
      prependItems?.map(i => ({
        name: i.name,
        text: i.name,
        search_type: i.search_type ?? i.slug,
        category_ids: i.search_type ?? i.slug,
        order_by: i.order_by,
        slug: i.search_type ?? i.slug,
        department_no: "",
        allow_add_manual_department: "0",
        is_mealkit: i.is_mealkit ?? "0",
        product_count: i.product_count ?? "0",
      })),
    [prependItems]
  )
 
  
  const weeklyAdsInTree = updatedDepartmentTree.find(i => i.slug === WEEKLY_ADS_SLUG)
  const weeklyAdsInProductCategoryIndex = productCategoryAndWeeklyAds.findIndex(i => i.slug === WEEKLY_ADS_SLUG)
  if (weeklyAdsInTree && weeklyAdsInProductCategoryIndex !== -1) {
    updatedDepartmentTree.splice(updatedDepartmentTree.indexOf(weeklyAdsInTree), 1)
    productCategoryAndWeeklyAds[weeklyAdsInProductCategoryIndex] = {
      ...productCategoryAndWeeklyAds[weeklyAdsInProductCategoryIndex],
      ...weeklyAdsInTree,
    }
  }

  return {
    updatedDepartmentTree: getList(updatedDepartmentTree, productCategoryAndWeeklyAds),
    updatedOtherDepartmentTree: getList(updatedOtherDepartmentTree, productCategoryAndWeeklyAds),
  }
}

function getList(list, productAndCategory) {
  return list?.length > 1 ? [...productAndCategory, ...list] : list
}
